import { api } from '@/lib/api'

import { CreatedDolarAppRecipient, CreatedRecipient, Recipient } from '../types'

export function createRecipient(
  data: CreatedRecipient | CreatedDolarAppRecipient,
) {
  return api.post<Recipient>(`/v2/me/beneficiaries`, data)
}
